import { ISocketMessage } from './common';
import { ESocketMessageTypeDTO } from '../consts/socket-message-type';
import { ChatMessageViewModelFactory, IChatMessage } from '../chat-message.view-model';
import { WebsocketChatMessage } from '@core/realtime/websocket';

export interface IChatMessageEventDTO extends ISocketMessage, WebsocketChatMessage {
  type: ESocketMessageTypeDTO.ChatMessage;
}

export class ChatMessageEventSocketMessageViewModelFactory {
  static createMessageFromDTO(dto: WebsocketChatMessage): IChatMessage {
    return ChatMessageViewModelFactory.createMessageFromDTO(dto);
  }
}
